import React from "react";

const TableNoDataIndication = ({
    loading = false,
    loadingText = "Loading...",
    noDataText = "No record found",
}) => {
    return (
        <div className="d-flex justify-content-center align-items-center py-4">
            {loading ? (
                <div className="text-center">
                    <div className="spinner-border text-primary mb-2" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <h6 className="text-muted mb-0">{loadingText}</h6>
                </div>
            ) : (
                <h6 className="text-muted mb-0">{noDataText}</h6>
            )}
        </div>
    );
};

export default TableNoDataIndication;
